import gql from "graphql-tag";

export default gql`
	mutation loginOtp($otp: String!) {
		loginOtp(otp: $otp) {
			success
		}
	}
`;
